// src/components/Icon.tsx
import React from 'react'
import type { IconType } from 'react-icons'

// Explicitly describe the props we're passing through
export interface IconProps {
  /** The icon component itself (e.g. `SiReact`) */
  icon: IconType
  size?: number
  color?: string
  className?: string
}

/**
 * Thin TS-friendly wrapper around any react-icon.
 * Returns a ReactElement explicitly, never `undefined`.
 */
export const Icon = ({
  icon: IconComponent,
  size = 24,
  color,
  className,
}: IconProps) => {
  // @ts-ignore: IconType is a valid component but TypeScript can't verify it
  return <IconComponent size={size} color={color} className={className} />
}
